import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import FilterIcon from "@material-ui/icons/FilterListOutlined";
import { DisplayDrawerContext } from "../../../../layout/DisplayDrawerContext";
import { useTradeByProductsReportFilter } from "../../../../data/reports/exchbusiness/tradeByProducts/hooks/useTradeByProductsReportFilter";
import { LocalizationContext } from "../../../../core/localization/Localization";
import { CustomTooltip } from "../../../components/common/CustomTooltip";
import { TradeByProductsFilterEditor } from "./TradeByProductsFilterEditor";

export const TradeByProductsReportFilter: React.FunctionComponent = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const showFilter = React.useCallback(
    () => showWithDrawer(<TradesByProductsFilterEditor />),
    [showWithDrawer]
  );

  const [filter, editfilter, save] = useTradeByProductsReportFilter();
  const { getString } = React.useContext(LocalizationContext);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <CustomTooltip titleKeyword="filterTooltip">
          <IconButton color="secondary" component="span" onClick={showFilter}>
            <FilterIcon />
          </IconButton>
        </CustomTooltip>
      </Grid>
    </Grid>
  );
};

const TradesByProductsFilterEditor: React.FunctionComponent = () => {
  const [filter, editFilter, save] = useTradeByProductsReportFilter();
  return (
    <TradeByProductsFilterEditor
      filter={filter}
      editFilter={editFilter}
      save={save}
    />
  );
};
